var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[(_vm.data.dots_enddate==null)?_c('create-form',{on:{"submitForm":_vm.submitData}}):_c('v-card',[_c('v-card-title',[_vm._v("Your DOT Activity has been finished on "+_vm._s(_vm.data.dots_enddate))])],1)],1)],1),_c('v-row',[_c('v-col',[_c('list',{attrs:{"datas":_vm.datas}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }